import React from "react";
import PropTypes from "prop-types";
import { Col, Row, FormGroup, FormControl } from "react-bootstrap";
import { Grid, Box, Button, Card, CardHeader, CardActionArea, CardMedia, CardActions, Link, CardContent, Avatar, Typography } from "@mui/material";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FeedIcon from '@mui/icons-material/Feed';
import { indigo } from "@mui/material/colors";
import { MdSupportAgent } from "react-icons/md";
import { PatientData } from "../Contexts";
import Messages from "./Messages";
import * as CONST from "../Constants";
import * as API from "../api";

const propTypes = {
  dispatch: PropTypes.func.isRequired,
};
SpecialistReferralsPage.prototype = propTypes;

export default function SpecialistReferralsPage(props) {
  const patient = React.useContext(PatientData);
  let [specialistReferrals, setSpecialistReferrals] = React.useState(null);

  const getSpecialistReferrals = async () => {
    const data = await API.getSpecialistReferrals();
    if (specialistReferrals == null) {
      setSpecialistReferrals(data.specialist_referrals)
    }
  };

  React.useEffect(() => {
    if(specialistReferrals == null) {
      getSpecialistReferrals().catch(console.error);
    }
  }, [getSpecialistReferrals]);

  const SpecialistReferralContainer = (props) => {
    return(
      <>
        <Card className='m-t-lg'>
          <CardContent sx={{ minWidth: 275 }}>
            <Typography gutterBottom sx={{ color: 'text.secondary', float: 'right', fontSize: 14 }}>
              <a style={{ textDecoration: 'none !important' }} href={ props.specialistReferral.document_url }>
                <DownloadForOfflineIcon />  Referral
              </a>
            </Typography>
            <Typography variant="h5" component="div">
              <LocalHospitalIcon /> { props.specialistReferral.specialist_type }
            </Typography>
            <hr />
            <Typography variant="body2">
              <Grid>
                <Row>
                  <Col xs={12} sm={12} md={6}>
                    Specialist: <b>{ props.specialistReferral.specialist }</b> <br />
                    Group: <b>{ props.specialistReferral.specialist_group }</b> <br />
                    Address: <b>{ props.specialistReferral.specialist_practice_address ? props.specialistReferral.specialist_practice_address : (
                      <>
                        <b>
                          <Link href={ props.specialistReferral.document_url } >Click here to view</Link>
                        </b>
                      </>) }</b><br />
                    Phone: <b>{ props.specialistReferral.specialist_practice_phone ?
                      props.specialistReferral.specialist_practice_phone : (<>
                        <b><Link href={ props.specialistReferral.document_url } >Click here to view</Link></b>
                      </>) }</b> <br />
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                    Referral Date: <b>{ props.specialistReferral.referral_date }</b> <br />
                    Duration: <b>{ props.specialistReferral.duration }</b> <br />
                    Expiration Date: <b>{ props.specialistReferral.expiration_date }</b> <br />
                  </Col>
                </Row>
              </Grid>
            </Typography>
          </CardContent>
          <CardActions>
            <Grid>
              <Row>
                <Col md={12} className="form">
                  { props.specialistReferral.document_url && (
                    <>
                      <b><Link href={ props.specialistReferral.document_url } >Click here to view referral document</Link></b>
                    </>
                  )}
                </Col>
              </Row>
            </Grid>
          </CardActions>
        </Card>
        <br />
      </>
    )
  };

  return (
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={12}>
        <Card className="patient-feed-card">
          <Box pt={2.5} pb={2} pl={2} pr={2}>
            <CardHeader
              className="cpr"
              avatar={
                <Avatar sx={{ color: indigo[900], bgcolor: "#f6f6f6" }}>
                  <FeedIcon />
                </Avatar>
              }
              title={'Specialist Referrals'}
              subheader={
                <>
                  <p className='m-t-md'>
                    <i class='med-text'>
                      Referrals entitle you to a $20 specialist visit copay, valid through the expiration date listed.
                      <br />Referrals are faxed to the specialist. If you haven’t already scheduled your appointment, please contact the specialist at the number provided.
                      <br />You may also print the attached referral and present it at the time of your visit.
                      <br />If you need a new or revised referral plan, contact wellPORTAL at 702-533-4353 or <a href={'/patient_portal/general_support'}>go to general support.</a>
                    </i>
                  </p>
              </>
              }
            />
          </Box>
        </Card>
        { specialistReferrals && specialistReferrals.length > 0 && specialistReferrals.map((el, i) => {
            return <SpecialistReferralContainer specialistReferral={el} key={i} />
          })
        }
      </Grid>
    </Grid>
  );
}
